import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from "../../../shared/services/session.service";
import { AlertPopupService } from "../../../shared/services/alert-popup.service";
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CustomerDoLogin, CustomerDoRegister } from "../../../states/auth/auth.actions";
import { RegexEnum } from "../../../core/enums/regex.enum";
import { Location } from "@angular/common";

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
	public form: FormGroup;
	public form1: FormGroup;
	private _selectedTab = 'mobile';

	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
		private formBuilder: FormBuilder,
		private store: Store,
		private location: Location
	) {
	}

	get selectedTab(): string {
		return this._selectedTab;
	}

	set selectedTab(value: string) {
		this._selectedTab = value;
	}

	ngOnInit(): void {
		this.sessionService.unsetState();
		localStorage.clear()
		sessionStorage.clear()
		this.subscribeToSession();
		this.initializeForm();
	}

	subscribeToSession() {
		if (this.sessionService.state?.profile) {
			this.router.navigate(['']);
			this.alertPopupService.showWarningAlert('You already have an active session!!!');
		}
	}

	public emailOrMobileValidator(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
			const mobileRegex = /^[7-9][0-9]{9}$/;

			const value = control.value;

			if (!emailRegex.test(value) && !mobileRegex.test(value)) {
				return { 'emailOrMobile': true };
			}

			return null;
		};
	}

	initializeForm(): void {
		this.form = this.formBuilder.group({
			// emailId: ['', [Validators.email]],
			// mobile: ['', [Validators.pattern(RegexEnum.PhoneNumberRegexWithCode)]],
			emailOrMobile: ['', [Validators.required, this.emailOrMobileValidator()]],
			password: ['', [Validators.required, Validators.pattern(RegexEnum.PasswordRegex)]],
		},
			// {
			// 	validator: (formGroup) => {
			// 		const emailField = formGroup.controls['emailId'].value
			// 		const mobileField = formGroup.controls['mobile'].value
			// 		if (emailField && mobileField) {
			// 			return {
			// 				emailAndMobile: true
			// 			}
			// 		} else if (emailField || mobileField) {
			// 			return null
			// 		} else {
			// 			return {
			// 				emailOrMobile: true
			// 			}
			// 		}
			// 	}
			// }
		);

		this.form1 = this.formBuilder.group({
			// mobile: ['', [Validators.required, Validators.pattern(RegexEnum.PhoneNumberRegexWithCode)]],
			mobile: ['', [Validators.required, Validators.pattern(RegexEnum.Numeric), Validators.minLength(10), Validators.maxLength(10)]],
		});
	}

	public markTouchedAndDirty(value: string | boolean, key: string, form: FormGroup): void {
		form.controls[key].markAsTouched();
		if (!value) {
			form.controls[key].markAsDirty();
		}
	}

	public onSubmit(form: FormGroup): void {
		try {

			if (form.valid) {
				if (this.selectedTab === 'email') {
					const payload: any = {}
					const emailOrMobileValue: string = form.value.emailOrMobile;

					// if (form.value.emailId) {
					// 	payload.emailId = form.value.emailId
					// }
					// if (form.value.mobile) {
					// 	payload.mobile = form.value.mobile
					// }
					if (emailOrMobileValue.includes('@')) {
						payload.emailId = emailOrMobileValue
					} else {
						payload.mobile = '+91' + emailOrMobileValue;
					}
					if (form.value.password) {
						payload.password = form.value.password
					}
					this.store.dispatch(new CustomerDoLogin(payload));
				}

				if (this.selectedTab === 'mobile') {
					this.store.dispatch(new CustomerDoRegister({
						isFirstTime: false,
						mobile: '+91' + form.value.mobile,
					}));
				}
			} else {
				form.markAllAsTouched();
				this.alertPopupService.showWarningAlert('You missed to fill some required fields.');
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}

	backBtnClick() {
		this.location.back();
	}
}
